import $http from "@/http/http";
/**
* @description: 示例

// form-data 请求方式
export const 接口名 = data => {
    return $http.post("接口地址", data);
};

// json 请求方式
export const 接口名 = data => {
    return $http.post("接口地址", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
*/
// 设备台账维护 —— 获取树
export const getUnitDocTreeList = data => {
    return $http.post("/operation/doc_tree/getUnitDocTreeList", data);
};

// 设备台账维护 —— 获取右侧列表的标题
export const getTitleDocColumList = data => {
    return $http.post("/operation/doc_tree/getTitleDocColumList", data);
};
// 设备台账维护 —— 获取右侧列表的数据
export const getDocColumList = data => {
    return $http.post("/operation/doc_tree/getDocColumList", data);
};
// 设备台账维护 —— 50获取设备
export const getTreeTypeRelation = data => {
    return $http.post("/operation/doc_tree/getTreeTypeRelation", data);
};
// 设备台账维护 —— 新增
export const getAddColumId = data => {
    return $http.post("/operation/doc_tree/getAddColumId", data);
};
// 设备台账维护 —— 删除
export const delTree = data => {
    return $http.post("/operation/doc_tree/delTree", data);
};
// 设备台账维护 —— 修改查询
export const getUpdateDocTreeColum = data => {
    return $http.post("/operation/doc_tree/getUpdateDocTreeColum", data);
};
// 设备台账维护 —— 查看
export const getDocTreeColum = data => {
    return $http.post("/operation/doc_tree/getDocTreeColum", data);
};
// 设备台账维护 —— 下拉
export const getSelect = data => {
    return $http.post("/operation/doc_tree/getSelect", data);
};
// 设备台账维护 —— 下拉二
export const getSelectTwo = data => {
    return $http.post("/operation/doc_tree/getTreeType", data);
};
// 设备台账维护 —— 修改保存
export const updateTreeColum = data => {
    return $http.post("/operation/doc_tree/updateTreeColum", data);
};
// 设备台账维护 —— 保存
export const docInsert = data => {
    return $http.post("/operation/doc_tree/insert", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getRushRepairs = data => {
    return $http.post("/operation/rushrepair/getRushRepairs", data);
};
//获取用户信息
export const getUserInfo = data => {
    return $http.post("base/common/getUserInfo", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const deleteRushRepair = data => {
    return $http.post("/operation/rushrepair/deleteRushRepair ", data);
};
export const getLeader = data => {
    return $http.post("/operation/rushrepair/getLeader", data);
};
export const saveRushRepair = data => {
    return $http.post("/operation/rushrepair/saveRushRepair", data);
};
export const addBackfill = data => {
    return $http.post("/operation/rushrepair/addBackfill", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getBackfill = data => {
    return $http.post("/operation/rushrepair/getBackfill", data);
};
// 1-4上传图片（有权限）--------王智超
export const uploadAvatar = data => {
    return $http.post("/collect/common/getImg", data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

export const getCodelistByKind = data => {
    return $http.post("/collect/common/getCodelistByKind", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export const selectTaskList = data => {
    return $http.post("/operation/ope_report_repair/selectTaskList", data);
};

export const selectReportRepairInfo = data => {
    return $http.post(
        "/operation/ope_report_repair/selectReportRepairInfo",
        data
    );
};

export const updateState = data => {
    return $http.post("/operation/ope_report_repair/updateState", data);
};

export const updateRushRepairId = data => {
    return $http.post("/operation/ope_report_repair/updateRushRepairId", data);
};

export const insertRepair = data => {
    return $http.post("/operation/ope_report_repair/insertRepair", data);
};

export const updateCheckContent = data => {
    return $http.post("/operation/ope_report_repair/updateCheckContent", data);
};

/** 缺陷管理 **/
//获得缺陷管理信息列表
export const getDefectList = data => {
    return $http.post("/operation/defect/getDefectList", data);
};

//获得缺陷管理详细信息
export const getDefectById = data => {
    return $http.post("/operation/defect/getDefectById", data);
};

//缺陷管理保存修改
export const saveDefect = data => {
    return $http.post("/operation/defect/saveDefect", data);
};

//删除缺陷管理信息
export const deleteDefectById = data => {
    return $http.post("/operation/defect/deleteDefectById", data);
};

/** 检修管理 **/
//获得检修计划信息列表
export const getCheckList = data => {
    return $http.post("/operation/check_repair/getCheckList", data);
};
//删除检修项目信息
export const deleteCheckById = data => {
    return $http.post("/operation/check_repair/deleteCheckById", data);
};
//获取检修
export const getCheckById = data => {
    return $http.post("operation/check_repair/getCheckById", data);
};
//保存检修计划信息列表
export const saveCheck = data => {
    return $http.post("/operation/check_repair/saveCheck", data);
};
//获取检修结果列表
export const getCheckResultList = data => {
    return $http.post("operation/check_repair/getCheckResultList", data);
};
//获取检修项目信息
export const getCheckResultById = data => {
    return $http.post("/operation/check_repair/getCheckResultById", data);
};
//保存检修信息回填
export const saveCheckResult = data => {
    return $http.post("/operation/check_repair/saveCheckResult", data);
};
//查询工作票
export const getTicketList = data => {
    return $http.post("/operation/check_repair/getTicketList", data);
};
//删除工作票
export const deleteTicket = data => {
    return $http.post("/operation/check_repair/deleteTicket", data);
};
//查看工作票
export const getTicketById = data => {
    return $http.post("/operation/check_repair/getTicketById", data);
};
//保存工作票
export const saveTicket = data => {
    return $http.post("/operation/check_repair/saveTicket", data);
};
//查询操作票
export const getTicketOperationList = data => {
    return $http.post("/operation/check_repair/getTicketOperationList", data);
};
//删除操作票
export const deleteTicketOperation = data => {
    return $http.post("/operation/check_repair/deleteTicketOperation", data);
};
//查看操作票
export const getTicketOperationById = data => {
    return $http.post("/operation/check_repair/getTicketOperationById", data);
};
//保存操作票
export const saveTicketOperation = data => {
    return $http.post("/operation/check_repair/saveTicketOperation", data);
};
//查看设备
export const getCheckRepairParts = data => {
    return $http.post("/operation/check_repair/getCheckRepairParts", data);
};
//添加设备
export const saveCheckRepairParts = data => {
    return $http.post("/operation/check_repair/saveCheckRepairParts", data);
};
//查看工作总结
export const getRepairResultRemark = data => {
    return $http.post("/operation/check_repair/getRepairResultRemark", data);
};
//保存工作总结
export const saveRepairResultRemark = data => {
    return $http.post("/operation/check_repair/saveRepairResultRemark", data);
};
//抢修，报修，缺陷，巡检
export const selectPlanInfoListByPage = data => {
    return $http.post(
        "/operation/ope_inspection/selectPlanInfoListByPage",
        data
    );
};
export const updatePlanState = data => {
    return $http.post("/operation/ope_inspection/updatePlanState", data);
};
export const updatePlanInfo = data => {
    return $http.post("/operation/ope_inspection/updatePlanInfo", data);
};
export const insertPlanInfo = data => {
    return $http.post("/operation/ope_inspection/insertPlanInfo", data);
};
export const deletePlanInfo = data => {
    return $http.post("/operation/ope_inspection/deletePlanInfo", data);
};
export const selectTaskTree = data => {
    return $http.post("/operation/ope_inspection/selectTask_tree", data);
};
export const insertTaskResult = data => {
    return $http.post("/operation/ope_inspection/insertTask_result", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const updateTaskInfo = data => {
    return $http.post("/operation/ope_inspection/updateTaskInfo", data);
};
export const selectTaskListByPage = data => {
    return $http.post("/operation/ope_inspection/selectTaskListByPage", data);
};
